import { Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from '../_services/toastr.service';
import { ErrorService } from '../_services/error.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy, DoCheck {
  model: any = {};
  loginForm: FormGroup;
  appName: any;
  copyright: any;
  socialProviders: string[] = [];
  isExternalLoginAllowed = false;
  baseUrl = environment.apiUrl + 'Account';

  password: any;
  confirmNewPassword: any;
  email: any;

  passwordErrors: any[] = [];
  confirmPasswordErrors: any[] = [];

  isLoading: boolean = false;

  userId: any;
  code: any;

  errors: any;

  isForgotPassword: boolean = false;
  showMessageSendEmail: boolean = false;
  canSendEmail: boolean = false;
  canSendPassword: boolean = false;
  buttonValidation: boolean = false;

  private passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
  private emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  constructor(
    private authService: AuthService,
    private toastrService: ToastrService,
    private appComponent: AppComponent,
    private route: ActivatedRoute,
    private router: Router,
    private errorService: ErrorService
  ) {
    if (this.authService.isLoggedIn()) {
      router.navigate(['home']);
    }
  }

  ngOnInit() {
    this.appComponent.setTitle('Verify Email');
    this.email = localStorage.getItem('pendingEmail');

    this.route.queryParams.subscribe((params) => {
      this.userId = params['userId'];
      this.code = params['code'];
    });

    if (!this.userId) {
      this.isForgotPassword = true;
    }
  }

  ngDoCheck(): void {
    this.canSendEmail = !!this.email && this.emailRegex.test(this.email);

    const isPasswordValid =
      this.password && this.passwordRegex.test(this.password);
    const doPasswordsMatch =
      this.password &&
      this.confirmNewPassword &&
      this.password === this.confirmNewPassword;
    this.canSendPassword = isPasswordValid && doPasswordsMatch;

    this.buttonValidation = this.isForgotPassword
      ? this.canSendEmail
      : this.canSendPassword;
    window.console.log(
      'isForgotPassword',
      this.isForgotPassword,
      'buttonValidation',
      this.buttonValidation
    );
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
  }

  changePassword() {
    this.isLoading = true;

    if (this.isForgotPassword) {
      this.authService.forgotPassword(this.email).subscribe({
        next: (res) => {
          this.showMessageSendEmail = true;
          this.isLoading = false;
        },
        error: (e) => {
          this.errors = this.errorService.getErrors();
          window.console.log('errores: ', this.errors);
          this.isLoading = false;
          this.showMessageSendEmail = true;
        },
      });
    } else {
      this.authService
        .resetPassword({
          id: this.userId,
          password: this.password,
          confirmPassword: this.confirmNewPassword,
          code: this.code,
        })
        .subscribe({
          next: (res) => {
            this.toastrService.success('Contraseña cambiada con éxito');
            this.router.navigate(['/']);
          },
          error: (e) => {
            this.errors = this.errorService.getErrors();
            window.console.log('errores: ', this.errors);
            this.passwordErrors = this.errors.Password;
            this.confirmPasswordErrors = this.errors.ConfirmPassword;
            this.isLoading = false;
          },
        });
    }
  }
}
